import React, { FC } from 'react';
import { Image, View } from 'react-native';
import { ProgressiveImageProps } from '.';
import Processing from '@v2/components/imageHandling/components/Processing';
import { font as initialFont } from '@styles/fonts';
import { scale as initialScale } from '@components/frame';

interface ImageBase64Props extends Pick<ProgressiveImageProps, 'containerStyle' | 'width' | 'height' | 'font' | 'scale' | 'resizeMode'> {
  isProcessing?: boolean;
  base64?: string;
  angle?: number;
}

const ImageBase64: FC<ImageBase64Props> = ({
  base64,
  containerStyle,
  height,
  width,
  angle = 0,
  resizeMode = 'contain',
  scale = initialScale,
  font = initialFont,
  isProcessing = true,
}) => {
  if(!base64) return;
  return (
    <View style={[{ width, height }, containerStyle]}>
      {isProcessing && <Processing scale={scale} font={font} />}
      <Image source={{ uri: base64 }} style={{ width: '100%', height: '100%', transform: [{rotate: `${angle}deg`}] }} resizeMode={resizeMode} />
    </View>
  );
};

export default ImageBase64;
